<template>
  <div>
    <a-card :bordered="false">
      <s-table
        ref="table"
        size="small"
        rowKey="id"
        :loading="loading"
        :columns="columns"
        :pageNum="pageNum"
        :data="loadData"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <div slot="category" slot-scope="category">
          <h4>{{ templateCategory(category) }}</h4>
        </div>
        <span slot="action" slot-scope="text, record">
          <template>
<!--            <a @click="handleCreate(record)">审批</a>-->
<!--            <a-divider type="vertical"/>-->
            <a @click="handleWatch(record)">进度</a>
            <a-divider type="vertical"/>
            <a @click="handleBill(record)">内容详情</a>
          </template>
        </span>
      </s-table>
    </a-card>
    <el-drawer title="发起审批" width="600px" :visible.sync="openItemDl">
      <div style="border-top: 1px solid #efefef">
        <initiate-process ref="processForm" type="data" :code="selectForm.id" v-if="openItemDl" style="padding: 0 20px; "></initiate-process>
        <div style="position: absolute; bottom: 10px; padding-top: 10px;text-align: center; border-top: 1px solid #efefef; width: 100%">
          <el-button size="mini" @click="openItemDl = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="submitRejectForm">拒 绝</el-button>
          <el-button size="mini" type="primary" @click="submitAgreeForm">同 意</el-button>
        </div>
      </div>
      <el-dialog :title="title" :visible.sync="visible" append-to-body width="500px">
        <el-form :model="selectForm">
          <el-form-item label="" label-width="0px">
            <el-input v-model="remark" placeholder="请输入审批意见"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visible = false">取 消</el-button>
          <el-button type="primary" @click="commitForm">确 定</el-button>
        </span>
      </el-dialog>
    </el-drawer>
  </div>
</template>

<script>
import { STable } from '@/components'
import ApproveForm from '@/views/a-trade/approve/admin/ApproveForm'
import InitiateProcess from '../workspace/InitiateProcess'

import { getApproveToDoList, doApproveToDo } from '@/api/oa_approve'
export default {
  name: 'TableShenPiToDoList',
  components: {
    STable,
    ApproveForm,
    InitiateProcess
  },
  data () {
    return {
      pageNum: 1,
      loading: false,
      visible: false,
      confirmLoading: false,
      mdl: {},
      openItemDl: false,
      title: '',
      result: 2,
      remark: '',
      selectForm: {},
      // 查询参数
      queryParam: {
        my_approval: true,
        is_completed: false
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: '50px',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '标题',
          dataIndex: 'approval_name',
          customRender: (text, record) => '"' + record.create_by + '"发起的【' + text + '】'
        },
        {
          title: '类型',
          dataIndex: 'category',
          scopedSlots: { customRender: 'category' }
        },
        {
          title: '发起人',
          dataIndex: 'create_by'
        },
        {
          title: '最近时间',
          dataIndex: 'last_update'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      categories: this.$Dictionaries.approval_category,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return getApproveToDoList(Object.assign(parameter, this.queryParam))
          .then(({ data }) => {
            return data
          })
      }
    }
  },
  created () {
    this.setCurrentPage()
  },
  computed: {
    templateCategory () {
      return (categories) => {
        return this.getLabelsByValues(categories.split(',')).join('/')
      }
    }
  },
  methods: {
    getLabelByValue (value, categories = this.$Dictionaries.approval_category) {
      for (const category of categories) {
        if (category.value === value) return category.label
        if (category.children) {
          const result = this.getLabelByValue(value, category.children)
          if (result) return result
        }
      }
      return undefined
    },
    getLabelsByValues (values) {
      const vv = values.map((value) => {
        const v = this.getLabelByValue(Number(value))
        return v
      }).filter((value) => value !== undefined)
      return vv
    },
    setCurrentPage () {
      // const page = sessionStorage.getItem('RentCurrentPage')
      const page = this.$store.getters.pop
      if (page) {
        console.log(page)
        const current = page.split('#$$#')[0]
        const query = page.split('#$$#')[1]
        const path = page.split('#$$#')[2]
        sessionStorage.removeItem('RentCurrentPage')
        if (path === this.$route.path) {
          if (!isNaN(Number(current))) {
            this.pageNum = Number(current)
          }
          if (query) {
            this.queryParam = JSON.parse(query)
          }
        } else {
          this.queryParam = { my_approval: true }
          this.$store.dispatch('clear')
        }
      }
    },
    handleCreate (record) {
      try {
        record.template.form_items = record.approval_content
        this.mdl = record
        this.selectForm = record.template
        this.selectForm.id = record.result_node.process_result_id + ''
        this.openItemDl = true
      } catch (e) {
        this.$message.error('数据错误')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk () {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          this.confirmLoading = false
          this.visible = false
          if (this.mdl) {
            this.handleApprove(this.mdl, values)
          }
        } else {
          this.confirmLoading = false
        }
        this.mdl = {}
      })
    },
    handleApprove (item, data) {
      console.log(item, data)
      doApproveToDo(item.id, data).then((res) => {
        console.log(res, '审批结果')
        this.$refs.table.refresh()
      })
    },
    handleEdit (item) {
      console.log(item)
      this.mdl = item
      this.visible = true
      this.confirmLoading = false
    },
    handleWatch (item) {
      console.log(item)
      // sessionStorage.setItem('RentCurrentPage', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$store.dispatch('push', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$router.push({
        path: '/oa/approval/todo/' + item.id + '/',
        query: {
          type: item.business_type
        }
      })
    },
    handleBill (record) {
      console.log(record)
      const category = record.template.category
      if (category !== undefined && category.indexOf(',') > 0) {
        const category_codes = category.split(',')
        if (category_codes.length > 0) {
          const category_first_code = Number(category_codes[0])
          const category_second_code = Number(category_codes[1])
          let category_key
          let category_children
          for (const c of this.categories) {
            if (c.value === category_first_code) {
              category_key = c.key
              category_children = c.children
            }
          }
          let business_type
          if (category_children) {
            for (const cc of category_children) {
              if (cc.value === category_second_code) {
                business_type = cc.key
                break
              }
            }
          }
          if (business_type) {
            if (category_key === 'trade') {
              this.$router.push({ path: '/trade/approval/todo_detail/', query: { type: business_type, data_id: record.data_id, id: record.id } })
            } else if (category_key === 'bill') {
              let path
              if (business_type === 'electricity_bill') {
                path = '/electricity_meter_record/' + record.data_id
              } else if (business_type === 'water_bill') {
                path = '/water_meter_record/' + record.data_id
              } else if (business_type === 'rent_bill') {
                path = '/rent_bill/index/' + record.data_id
              } else if (business_type === 'property_bill') {
                path = '/property_bill/index/' + record.data_id
              } else if (business_type === 'contract_bill') {
                path = '/contract/index/' + record.data_id
              } else if (business_type === 'guarantee_bill') {
                path = '/guarantee/index/' + record.data_id
              }
              if (path !== undefined) {
                this.$router.push({ path: path, query: { edit: false } })
              }
            }
          }
        }
      }
    },
    submitRejectForm () {
      this.title = '拒绝'
      this.result = 3
      this.visible = true
    },
    submitAgreeForm () {
      this.title = '同意'
      this.result = 2
      this.visible = true
    },
    commitForm () {
      this.$refs.processForm.validate(valid => {
        if (valid) {
          const formData = this.$refs.processForm.getFormData()
          const form = this.$refs.processForm.getForm()
          form.formItems = form.formItems.map(item => {
            if (formData.hasOwnProperty(item.id)) {
              item.value = formData[item.id]
            }
            return item
          })
          const strItems = JSON.stringify(form.formItems)
          if (this.selectForm !== undefined) {
            doApproveToDo(this.mdl.id, {
              form_items: strItems,
              result: this.result,
              remark: this.remark
            }).then(res => {
              console.log('启动流程', res)
              if (res.code === 1000) {
                this.openItemDl = false
                this.visible = false
                this.$message.success('提交成功')
                this.$refs.table.refresh()
              } else {
                this.$message.success('提交失败')
              }
            })
          }
        } else {
          this.$message.warning('校验失败')
        }
      })
    }
  }
}
</script>
